import { type VariantProps, cva } from 'class-variance-authority';
import type { ReactNode, JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';
import { Heading, Text, TextLink } from '../../';

export interface EventPracticalTileProps
    extends CommonProps,
        VariantProps<typeof EventPracticalTileStyles> {
    title: string;
    subTitle?: string;
    icon?: ReactNode;
    href?: string;
    onClick?: () => void;
}

export const EventPracticalTileStyles = cva(
    'relative click-area group overflow-hidden rounded-lg bg-gray-500 p-8'
);

export const EventPracticalTextStyles = cva('flex items-center');

export const EventPracticalTile = ({
    className,
    title,
    subTitle,
    icon,
    href,
    onClick,
    testId = 'event-practical-tile',
    ...props
}: EventPracticalTileProps): JSX.Element => {
    return (
        <div
            className={twMerge(EventPracticalTileStyles({ className }))}
            {...props}
            data-testid={testId}
        >
            <div
                className={twMerge(EventPracticalTextStyles())}
                onClick={onClick}
            >
                {icon}
                <TextLink
                    className="click-area-link ml-4 text-left no-underline hover:no-underline"
                    href={href}
                >
                    <div>
                        <Heading as="h5" className="mb-0">
                            {title}
                        </Heading>
                        <Text>{subTitle}</Text>
                    </div>
                </TextLink>
            </div>
        </div>
    );
};
